import {
  isEmpty,
  toNumber,
  reverse
} from "lodash"


/**
 * Takes in a number and returns the numbers ordinal
 *
 * ##### Example
 * `numberOrdinal(1); // <- "st"`
 * `numberOrdinal(2); // <- "nd"`
 * `numberOrdinal(3); // <- "rd"`
 * `numberOrdinal(121); // <- "st"`
 * `numberOrdinal(18); // <- "th"`
 * `numberOrdinal(33334); // <- "th"`
 * `numberOrdinal("hello"); // <- ""`
 *
 * @param num
 * @returns {string}
 */
export const numberOrdinal = (num) => {
  if (typeof num !== "number") return ""

  const s = String(num)
  const len = s.length
  const end = s.substr(len - 1, 1)
  const teen = len > 1 && s.substr(len - 2, 1) === "1"
  let ord = "th"

  if (end === "1" && !teen) {
    ord = "st"
  } else if (end === "2" && !teen) {
    ord = "nd"
  } else if (end === "3" && !teen) {
    ord = "rd"
  }

  return ord
}


/** Utils used in numToWords */
const arr = (x) => Array.from(x)
const num = (x) => toNumber(x) || 0
const take = (n) => (xs) => xs.slice(0, n)
const drop = (n) => (xs) => xs.slice(n)
const comp = (f) => (g) => (x) => f(g(x))
const not = (x) => !x
const chunk = (n) => (xs) => (isEmpty(xs) ? [] : [take(n)(xs), ...chunk(n)(drop(n)(xs))])


/**
 *
 * Adapted, but originaly taken from user633183's answer in:
 * https://stackoverflow.com/questions/14766951/convert-digits-into-words-with-javascript
 *
 *
 * @param n
 * @returns {*}
 */
export const numToWords = (n) => {
  const a = [
    "", "one", "two", "three", "four",
    "five", "six", "seven", "eight", "nine",
    "ten", "eleven", "twelve", "thirteen", "fourteen",
    "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"
  ]
  const b = [
    "", "", "twenty", "thirty", "forty",
    "fifty", "sixty", "seventy", "eighty", "ninety"
  ]
  const g = [
    "", "thousand", "million", "billion", "trillion", "quadrillion",
    "quintillion", "sextillion", "septillion", "octillion", "nonillion"
  ]
  const makeGroup = ([ones, tens, huns]) => {
    return [
      num(huns) === 0 ? "" : `${a[huns]} hundred`,
      b[tens] || "",
      a[tens + ones] || a[ones]
    ].join(" ")
  }
  const thousand = (group, i) => (group === "" ? group : `${group} ${g[i]}`)
  if (typeof n === "number") return numToWords(String(n))
  if (n === "0") return "zero"
  return comp(chunk(3))(reverse)(arr(n))
    .map(makeGroup)
    .map(thousand)
    .filter(comp(not)(isEmpty))
    .reverse()
    .join(" ")
    .replace("  ", " ")
    .trim()
}
